import React from 'react'
import { useState, useEffect } from 'react'
import $ from "jquery";
import "./bottomNavbar.css"

export default function BottomNavbar() {
  const [activeElement, setActiveElement] = useState("feed");

  useEffect(() => {
    $(".homeContainer > .sidebar").removeClass("active");
    $(".homeContainer > .feed").removeClass("active");
    $(".homeContainer > .rightbar").removeClass("active");
    $(".homeContainer > ." + activeElement).addClass("active");
  }, [activeElement])

  return (
    <>
      <div className="bottomNavbar">
        <button onClick={() => setActiveElement("sidebar")}>
          Sidebar
        </button>
        <button onClick={() => setActiveElement("feed")}>
          Feed
        </button>
        <button onClick={() => setActiveElement("rightbar")}>
          Rightbar
        </button>
      </div>
    </>
  )
}